import { List, Text } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import type { ValidationWarningIssueDto } from "~/gen/api"

interface BulkUpdateWarningsSummaryProps {
  readonly validationWarnings: readonly ValidationWarningIssueDto[]
}

export const BulkUpdateWarningsSummary = ({
  validationWarnings,
}: BulkUpdateWarningsSummaryProps) => {
  const { t } = useTranslation("dataTransfer")
  if (validationWarnings.length === 0) {
    return null
  }

  return (
    <InfoBox
      variant="warning"
      title={t("import.bulkUpdate.summaryModal.warningsTitle")}
      message={
        <List mah={300} style={{ overflowY: "auto" }}>
          {validationWarnings.map((warning: ValidationWarningIssueDto) => (
            <List.Item key={warning.unicityKey}>
              <Text fz="xs" key={warning.unicityKey}>
                {warning.type === "invalidHeader"
                  ? `Invalid headers: ${warning.message}`
                  : `Warning: ${warning.message} ${warning.unicityKey ? ` - ${warning.unicityKey}` : ""}`}
              </Text>
            </List.Item>
          ))}
        </List>
      }
    />
  )
}
